import { Permission } from '@cims-online/shared'
import { simpleRemoveNotification } from 'hooks/notificationHandler'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { RemoveRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import {
  RoutingGroup,
  useRoutingGroupsTableContext,
} from '../../../../RoutingGroupsTableContext'
import { useSoftRemoveCasRoutingGroupMutation } from 'schema'

export function useRemoveOptions(): RemoveRowActionOptions<RoutingGroup> {
  const { refetch } = useRoutingGroupsTableContext()
  const [removeRoutingGroup] = useSoftRemoveCasRoutingGroupMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      softRemoveCASRoutingGroup: {
        routingGroup: { name },
      },
    }) => simpleRemoveNotification(name),
  })
  return {
    disabled: ({ casToCASRoutingGroups, users }) =>
      !!casToCASRoutingGroups.length || !!users.length
        ? {
            message:
              'Routing Groups cannot be deleted if they have any associated users or are associated with any Submittals',
          }
        : false,
    permission: Permission.RemoveRestoreCASRoutingGroup,
    onRemove: async ({ id }) => {
      await removeRoutingGroup({ variables: { id } })
      refetch()
    },
  }
}
